import React from 'react'
import BarChart from '../../../components/Charts/BarChart'
import * as CHART_UTILS from '../../../components/Charts/BarChart.constant'

const Idletime = ({ groupedData }) => {
  const chartLabels = []
  const data = []

  if (groupedData) {
    for (const hourlyData of groupedData) {
      let totalQuantity = 0

      if (!Array.isArray(hourlyData.data)) {
        chartLabels.push(hourlyData.hour)
        data.push(totalQuantity)
        continue
      }

      hourlyData.data.forEach((data) => {
        totalQuantity += data.idleTime
      })

      chartLabels.push(hourlyData.hour)
      data.push(totalQuantity)
    }
  }

  const dataGroup = [
    {
      ...CHART_UTILS.BAR,
      label: 'Idletime',
      data: data,
      backgroundColor: '#7afade',
      borderColor: '#04b890',
      barThickness: 15
    }
  ]

  return (
    <div
      style={{
        padding: '16px',
        height: '100%'
      }}
    >
      <BarChart
        chartTitle="Hourly idletime"
        chartLabels={chartLabels}
        dataGroup={dataGroup}
        xLabel="Hours"
        yLabel="Idletime"
        minValue={0}
        maxValue={60}
        stepValue={5}
        height="35%"
      />
    </div>
  )
}

export default Idletime
